import it from '@/i18n/it.json'
import en from '@/i18n/en.json'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem('lang') || 'it',
  messages: {
    it: it,
    en: en
  }
})
